// extracted by mini-css-extract-plugin
module.exports = {"PosterContent":"Poster_PosterContent__1YQRH"};